var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSketchpadIconblackinwhitecircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 207,
    viewBox: "0 0 207 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 103.5,
    r: 103.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.7148 163.021H77.1631V149.464H90.7148V163.021ZM63.6309 163.01H50.126V149.464H63.6309V163.01ZM155.225 109.177C156.002 109.177 156.755 109.323 157.484 109.614C158.214 109.906 158.846 110.344 159.381 110.927L163.391 115.011C163.974 115.545 164.4 116.177 164.667 116.906C164.934 117.635 165.068 118.365 165.068 119.094C165.068 119.871 164.934 120.613 164.667 121.317C164.4 122.022 163.974 122.667 163.391 123.25L124.964 161.677H112.568V149.281L151.068 110.854C151.652 110.32 152.295 109.906 153 109.614C153.705 109.323 154.447 109.177 155.225 109.177ZM118.401 151.688V155.844H122.558L151.068 127.333L148.953 125.292L146.912 123.177L118.401 151.688ZM63.6543 135.91H50.126V122.375H63.6543V135.91ZM178.638 97.9443L170.521 108.791L104.237 57.9453L63.6523 89.1338V108.814H50.124V99.4688L37.9424 108.791L30 98.1074L104.237 41L178.638 97.9443Z",
    fill: "currentcolor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketchpadIconblackinwhitecircle);
export default __webpack_public_path__ + "static/media/Sketchpad Icon black in white circle.2bd90f5a.svg";
export { ForwardRef as ReactComponent };